<!-- ACE Mode Gradient Badge -->
@if(isAceDesign && useGradientPhil(topContentStyles)) {
<div
  class="px-[2px] pt-[2px] pb-1 z-[1] w-fit rounded-[40px] ml-[24px] mt-[13px] -mb-[15px] relative"
  [ngClass]="{'bg-transparent': !topContent, 'bg-ace-mode-gradient': topContent}">
    <div
      [className]="' w-fit rounded-[40px] px-[16px] h-[28px] flex items-center justify-center'"
      [ngClass]="{'bg-transparent': !topContent, 'bg-vis-dark': topContent }"
    >
      <span
        class="{{getTopContentStyles(topContentStyles)}}"
        [className]="' text-sm font-extrabold inline-block uppercase text-white'"
        >{{ topContent }}</span
      >
    </div>
  </div>
}
<!-- ACE Mode Non-Gradient Badge -->
@if(isAceDesign && !useGradientPhil(topContentStyles)) {
<div
  class="px-[2px] pt-[2px] pb-1 z-[1] w-fit rounded-[40px] ml-[24px] mt-[13px] -mb-[15px] relative"
  [ngClass]="{'bg-transparent': !topContent, 'bg-[#109aa1]': topContent}">
    <div
      [className]="' w-fit rounded-[40px] px-[16px] h-[28px] flex items-center justify-center'"
      [ngClass]="{'bg-transparent': !topContent, 'bg-[#c4eef2]': topContent }"
    >
      <span
        class="text-sm font-extrabold inline-block uppercase text-dark"
        >{{ topContent }}</span
      >
    </div>
  </div>
}
<!-- DEC & AARP Themed Badge -->
@if(!isAceDesign) {
  <div
    [className]="getThemeForTopBanner(topBackgroundColor, topTextColor).root + ' rounded-t-ace-mode w-full'"
    [ngClass]="{ 'h-9': !!topContent, 'h-0 lg:h-9': !topContent }"
    class="{{getTopContentStyles(topContentStyles)}}"
  >
    <span
      class="{{getTopContentStyles(topContentStyles)}}"
      [className]="
        getThemeForTopBanner(topBackgroundColor, topTextColor).root +
        ' text-sm font-extrabold rounded-t-ace-mode inline-block uppercase py-2 px-6 w-full'
      "
      >{{ topContent }}</span
    >
  </div>
}
